import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const ContainerIndicative = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin: 0 auto;
  width: 90%;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const TextThemes = styled.p`
  font-weight: 500;
  color: ${Variables.colorBlack};
  font-size: 22px;

  @media (max-width: 509px) {
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: 330px) {
    font-size: 17px;
  }
`;

export const ContainerIndicators = styled.p`
  box-sizing: border-box;
  display: inline-block;
  padding: 2px;
  width: 100px;
  text-align: center;
  background-color: ${Variables.colorBlack};
  color: ${Variables.colorWhite};
  border-radius: 15px;
  font-size: 15px;

  @media (max-width: 509px) {
    display: inline;
    margin-left: 0;
    width: 80px;
  }

  @media (max-width: 330px) {
    width: 60px;
  }
`;
